import CommercialSuppliersApi, {
  CreateCommercialSupplierPayload,
} from '../useCommercialSuppliers/api'

const createCommercialSupplier = async (payload: CreateCommercialSupplierPayload) =>
  CommercialSuppliersApi.createCommercialSupplier(payload)

export { createCommercialSupplier }
export type { CreateCommercialSupplierPayload }
